﻿/**
 * connections Module
 * @module connectionsModule
 * @namespace components.connectionsModule
 */
'use strict';

angular.module('components.connectionsModule', [
    'configure.configurationModule',
    'restangular',
    'ngCookies'
])
.factory('connectionsFactory', require('./connectionsFactory.js'));


//////////////////
// WEBPACK FOOTER
// ./source/angular/components/connections/index.js
// module id = 24
// module chunks = 0